import { ProtectedRoute } from "@/components/login/PortectedRoute";
import { queryClient } from "@/lib/queryClient";
import { LoginConfig } from "@/pages/LoginConfig";
import { Pointeuse } from "@/pages/Pointeuse";
import { Sessions } from "@/pages/Sessions";
import { Home } from "@/pages/Home"; 
import { isConfigured } from "@/services/config.services";
import { QueryClientProvider } from "@tanstack/react-query";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { useOfflineToast } from "@/hooks/useOfflineToast";
import { Toast } from "@/components/ui/toast";
import { Toaster } from "@/components/ui/sonner";
import { SettingsPage } from "@/pages/SettingsPage";
import AppLayout from "@/components/global/AppLayout";
import { Employes } from "@/pages/Employes";
import { WebSocketProvider } from "@/contexts/WebSocketConext";
import { Planning } from "@/pages/Planning";

const Index = () => {
  const configured = isConfigured();
  const { showToast, setShowToast } = useOfflineToast();

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="flex h-full min-h-0 max-h-full flex-col overflow-hidden">
          <WebSocketProvider>
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              <Routes>
        <Route
        path="/"
        element={configured ? <Navigate to="/home" /> : <LoginConfig />}
      />

      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/home" element={<Home />} />
        <Route path="/pointeuse" element={<Pointeuse />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/employes" element={<Employes />} />
      </Route>
              </Routes>
            </div>
          </WebSocketProvider>
          {/* Offline Toast - Affiché sur toute l'application */}
        {showToast && (
          <Toast
            message="Il semble que vous soyez déconnecté."
            description="Certaines fonctionnalités peuvent ne pas être disponibles. Veuillez vérifier votre connexion Internet."
            onClose={() => setShowToast(false)}
            duration={8000}
          />
        )}
        {/* Sonner Toaster pour les notifications */}
          <Toaster />
        </div>
      </Router>
    </QueryClientProvider>
  );
};

export default Index;
